// Services Section Data
import { SectionHeader, Service, ServiceItem } from '../data/schemas';

export const servicesData = {
  header: new SectionHeader("What I Offer", "Services", "services"),
  
  services: [
    new Service("Software Engineering", [
      new ServiceItem("Mobile app development (Flutter & React Native)"),
      new ServiceItem("Frontend & backend web development"),
      new ServiceItem("Clean architecture & scalable solutions"),
      new ServiceItem("Cross-platform applications")
    ]),
    
    new Service("Program Coordination & Training", [
      new ServiceItem("Tech bootcamps & educational programs"),
      new ServiceItem("Developer mentoring & support"),
      new ServiceItem("Curriculum development"),
      new ServiceItem("JavaScript & programming training")
    ]),
    
    new Service("Entrepreneurship & Business", [
      new ServiceItem("Business development strategies"),
      new ServiceItem("Startup consulting & guidance"),
      new ServiceItem("Innovation & growth planning"),
      new ServiceItem("Market analysis & opportunities")
    ]),
    
    new Service("Freelancing Services", [
      new ServiceItem("Custom software solutions"),
      new ServiceItem("Project-based development"),
      new ServiceItem("Technical consulting"),
      new ServiceItem("Independent contractor services")
    ]),
    
    new Service("Business Architecture & Consultancy", [
      new ServiceItem("System architecture design"),
      new ServiceItem("Enterprise solutions consulting"),
      new ServiceItem("Technology strategy planning"),
      new ServiceItem("Infrastructure & scalability advice")
    ]),
    
    new Service("Computer Engineering", [
      new ServiceItem("Systems engineering solutions"),
      new ServiceItem("Technical problem solving"),
      new ServiceItem("Engineering consulting"),
      new ServiceItem("Technology implementation")
    ])
  ]
};
